import { useFormikContext } from 'formik';
import styled from 'styled-components';
import Linkify from 'linkify-react';

const LinkifiedText = styled.div`
  > a {
    color: var(--overyield-blue);
  }
  white-space: pre-wrap;
`;

const LinkifiedTextDefault = styled(LinkifiedText)`
  color: var(--text-muted-color);
`;

const LinkifiedTextField = ({ type, onClick, value, defaultValue }) => {
  const { values } = useFormikContext();

  const shouldShowDefault =
    values[type] === '' || values[type] === defaultValue;

  const editedValue = shouldShowDefault ? defaultValue : values[type];

  return (
    <Linkify
      as={shouldShowDefault ? LinkifiedTextDefault : LinkifiedText}
      options={{ target: '_blank' }}
      onClick={onClick}
    >
      {editedValue || value || ''}
    </Linkify>
  );
};

export default LinkifiedTextField;
